import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import myStoredValue from './views/my-stored-value'
import myStoredValueDetails from './views/my-stored-value-details'
import myStoredValueCode from './views/my-stored-value-code'

export default [
  {
    path: RoutePathConstants.MY_STORED_VALUE,
    name: 'myStoredValue',
    component: myStoredValue
  },
  {
    path: RoutePathConstants.MY_STORED_VALUE_DETAILS,
    name: 'myStoredValueDetails',
    component: myStoredValueDetails
  },
  {
    path: RoutePathConstants.MY_STORED_VALUE_CODE,
    name: 'myStoredValueCode',
    component: myStoredValueCode
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/routers.js